import { render } from "./WarningsPortal.vue?vue&type=template&id=7aff3a72&scoped=true"
import script from "./WarningsPortal.vue?vue&type=script&lang=js"
export * from "./WarningsPortal.vue?vue&type=script&lang=js"

import "./WarningsPortal.vue?vue&type=style&index=0&id=7aff3a72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aff3a72"]])

export default __exports__